















import Vue, { PropType } from 'vue'
import { NavigationPillCard } from '@/components/partials/'
import RouteLink from '@/interfaces/app/RouteLink'

export default Vue.extend({
  components: {
    NavigationPillCard,
  },
  props: {
    routeLink: Object as PropType<RouteLink>,
    active: Boolean,
  },
})
